import { render } from "./ReliefReport.vue?vue&type=template&id=0604ca52&scoped=true"
import script from "./ReliefReport.vue?vue&type=script&lang=js"
export * from "./ReliefReport.vue?vue&type=script&lang=js"

import "./ReliefReport.vue?vue&type=style&index=0&id=0604ca52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0604ca52"]])

export default __exports__